<template>
  <div class="animated">
    <b-card>
      <b-card-header>
        <i class="icon-menu mr-1"></i>Data table Disbursement Log
      </b-card-header>
      <b-card-body>
        <disbursement-log-table></disbursement-log-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import DisbursementLogTable from './Table'

  export default {
    name: 'disbursement-log',
    components: {
      DisbursementLogTable
    }
  }
</script>
